const alias = 'COUNTRY_BY_SERVICE';

export const GET_COUNTRY_BY_SERVICE_REQUEST = `GET_${alias}_REQUEST`;
export const GET_COUNTRY_BY_SERVICE_SUCCESS = `GET_${alias}_SUCCESS`;
export const GET_COUNTRY_BY_SERVICE_FAILURE = `GET_${alias}_FAILURE`;
export const GET_COUNTRY_BY_SERVICE_RESET = `GET_${alias}_RESET`;
